import { giphyDarkGrey, giphyLightestGrey, giphyRed } from '@giphy/js-brand'
import { useState } from 'react'
import styled from 'styled-components'
import CreationToolUIAnimation from '../types/ui-animation'

const Tag = styled.div`
    ${CreationToolUIAnimation.css(CreationToolUIAnimation.PopIn)}
    background: ${giphyDarkGrey};
    border-radius: 20px;
    box-sizing: border-box;
    color: ${giphyLightestGrey};
    display: inline-block;
    font-size: 15px;
    font-weight: normal;
    height: 40px;
    line-height: 40px;
    max-width: 100%;
    overflow: hidden;
    padding: 0 36px 0 20px;
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:before {
        content: '#';
    }
`

const Remove = styled.div`
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-size: 11px;
    height: 20px;
    justify-content: center;
    line-height: 22px;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 10px;
    user-select: none;
    vertical-align: middle;
    width: 20px;

    &:hover {
        background: #000;
    }
`

type Props = {
    className?: string
    tag: string
    onRemove: (tag: string) => void
}

const CreationToolTags = ({ className, tag, onRemove }: Props) => {
    const [isRemoveHovered, setIsRemoveHovered] = useState<boolean>(false)
    const style = isRemoveHovered ? { background: giphyRed, color: '#000' } : undefined
    return (
        <Tag className={className} style={style}>
            {tag}
            <Remove
                className="ss-delete"
                onMouseOver={() => setIsRemoveHovered(true)}
                onMouseOut={() => setIsRemoveHovered(false)}
                onClick={() => onRemove(tag)}
            />
        </Tag>
    )
}

export default CreationToolTags
